.mainFeatured {
  margin: 16px 16px 0;
}

.deals {
  margin-top: 64px;
  margin-right: -16px;
  overflow: hidden;
}

.deal {
  height: 211px;
  width: 282px;
}

@media all and (--reefer-media-tablet-min) {
  .mainFeatured {
    margin: 16px 64px;
  }

  .deal {
    height: 288px;
    max-width: 423px;
  }
}
